import {authHeader, authHeaderImage, authHeaderPdf} from "./AuthHeader";

class ApiService {
    handleFetchResponse(res) {
        if (res.ok) {
            return res.json();
        } else {
            return res.json()
                .then(function (json) {
                    console.log(json);
                    return Promise.reject({
                        status: res.status,
                        ok: false,
                        message: json.message,
                        body: json
                    });
                })
        }
    }

    getAllUsersWithAdmin() {
        //non serve
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/all/admin`, {
            method: "GET",
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }

    getUserById(id) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/${id}`, {
            method: "GET",
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }

    createUser(body) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/admin/create`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: authHeader()
        })
    }

    editUser(id, body) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/update/${id}`, {
            method: "PUT",
            body: JSON.stringify(body),
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }

    searchByFilters(body, page, pageSize, sort, sortField) {
        let sortPath = '';
        if (sort && sortField) {
           sortPath = `&sort=${sort.toString().toUpperCase()}&sortField=${sortField}`
        }

        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/search?page=${page - 1}&pageSize=${pageSize}${sortPath}`, {
            method: "POST",
            headers: authHeader(),
            body: JSON.stringify(body)
        }).then(response => this.handleFetchResponse(response));
    }

    exportToExcel(body) {
        let url = `${process.env.REACT_APP_SERVER_URL}/user/export-to-excel`;

        return fetch(url, {
            method: "POST",
            headers: authHeader(),
            body: JSON.stringify(body)
        });
    }

    addSubscription(id, body) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user-subscription/add/${id}`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }

    editSubscription(id, subId, body) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user-subscription/update/${id}/${subId}`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }

    getAllSubscription() {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/subscription/all`, {
            method: "GET",
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }

    getQrCodeByUuid(uuid) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/qrcode/${uuid}`, {
            method: "GET",
            headers: authHeaderImage()
        });
    }

    getPdfByUuid(uuid, template) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/pdf/${uuid}/${template}`, {
            method: "GET",
            headers: authHeaderPdf()
        });
    }

    getSubsHistory(id) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/audit/subscription/${id}`, {
            method: "GET",
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }

    enableUser(userId) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/enable/${userId}`, {
            method: "GET",
            headers: authHeader()
        });
    }

    safeDeleteUser(id) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/safe-delete/id/${id}`, {
            method: "DELETE",
            headers: authHeader()
        });
    }

    sendChangePasswordToken(email) {
        return fetch(`${process.env.REACT_APP_SERVER_URL}/user/admin/sendChangePasswordToken?email=${email}`, {
            method: "GET",
            headers: authHeader()
        }).then(response => this.handleFetchResponse(response));
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ApiService();